(function () {
  const sectionSelector = '.collection-grid-section, .section-search';
  const sectionObservers = new Map();

  const calcMinHeight = (section) => {
    const facetsTop = section.querySelector('.facets__top');
    const sortWrapper = section.querySelector('.facets__sort-wrapper');
    const collectionWrapper = section.querySelector('.collection-wrapper');

    if (facetsTop && sortWrapper && collectionWrapper) {
      const rows = `${sortWrapper.getBoundingClientRect().height}px auto 1fr`;
      if (collectionWrapper.style.gridTemplateRows !== rows) {
        collectionWrapper.style.gridTemplateRows = rows;
      }
    }
  };

  const disconnectSection = (section) => {
    sectionObservers.get(section).disconnect();
    sectionObservers.delete(section);
  };

  const resizeCollectionGrid = () => {
    sectionObservers.forEach((observer, section) => {
      if (!section.isConnected) disconnectSection(section);
    });

    if (typeof ResizeObserver === 'undefined') return;

    // The custom product-list grid has no legacy row-height adjustment.
    document.querySelectorAll(sectionSelector).forEach((section) => {
      if (sectionObservers.has(section)) return;

      const observer = new ResizeObserver(() => calcMinHeight(section));
      sectionObservers.set(section, observer);
      observer.observe(section);
    });
  };

  document.addEventListener('shopify:section:load', resizeCollectionGrid);
  document.addEventListener('shopify:section:unload', (event) => {
    sectionObservers.forEach((observer, section) => {
      if (event.target === section || event.target.contains(section)) {
        disconnectSection(section);
      }
    });
  });

  resizeCollectionGrid();
})();
